module.exports = __webpack_public_path__ + "static/media/redeem-un-active.a0ba4d40.svg";